import React from "react";
import { withRouter } from "react-router-dom";
import JointHolderComponent from "./JointHolder.component";

const JointHolderLanding = () => {
  return <JointHolderComponent />
};
export default withRouter(JointHolderLanding);
